import { useTranslation } from "react-i18next";
import { Select } from "../../../components/fields/base/Select";
import { LANGUAGE_DISPLAY_NAMES, SUPPORTED_LANGUAGES, type SupportedLanguage } from "../../../i18n/languages";
import { useUpdateLanguagePreference } from "../api/useUpdateLanguagePreference";

const ITEMS = SUPPORTED_LANGUAGES.map((value) => ({ value, label: LANGUAGE_DISPLAY_NAMES[value] }));

export function LanguageSelector() {
  const { t, i18n } = useTranslation("common");
  const updateLanguagePreference = useUpdateLanguagePreference();

  const current =
    (SUPPORTED_LANGUAGES as readonly string[]).includes(i18n.resolvedLanguage ?? "") ?
      (i18n.resolvedLanguage as SupportedLanguage)
    : "en";

  return (
    <Select
      label={t(($) => $.common.language.Language)}
      items={ITEMS}
      value={current}
      onChange={(key) => {
        if (typeof key === "string") {
          void i18n.changeLanguage(key);
          updateLanguagePreference.mutate(key);
        }
      }}
      css={{ width: "100%" }}
    />
  );
}
